export default __webpack_public_path__ + "static/media/menu-check.68d15f1b.svg";